import { createSlice } from '@reduxjs/toolkit';

import type { Address } from '@/modules/address/domain/Address';
import {
  fetchAddresses,
  saveAddress,
  setDefaultAddress
} from '@/modules/address/infrastructure/AddressReduxRepository';

interface InitialState {
  data: Address[];
  isLoading: boolean;
}

const initialState: InitialState = {
  data: [],
  isLoading: false
};

const AddressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(saveAddress.fulfilled, (state, action) => {
        const isEdited = state.data.find(
          (address) => address.id === action.payload.id
        );

        if (isEdited) {
          state.data = state.data.map((address) =>
            address.id === action.payload.id ? action.payload : address
          );
        } else {
          state.data.push(action.payload);
        }
      })
      .addCase(fetchAddresses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(setDefaultAddress.fulfilled, (state, action) => {
        state.data = state.data.map((address) =>
          address.id === action.payload.id
            ? action.payload
            : { ...address, isDefault: false }
        );
      })
});

export const addressReducer = AddressSlice.reducer;
